import React from "react";
import _ from "lodash";

const Pagination = ({ itemsCount, pageSize, currentPage, onPageChange }) => {
  const pagesCount = Math.ceil(itemsCount / pageSize);
  if (pagesCount === 1) return null;

  let offset = 3;
  let offsetMax = offset + 2;

  if (pagesCount < 5) offsetMax = pagesCount;
  else {
    if (currentPage > 3) {
      offset = currentPage;
      offsetMax = offset + 2;
    }
    if (offsetMax > pagesCount) {
      offsetMax = pagesCount;
      offset = pagesCount - 2;
    }
  }
  const pages = _.range(offset - 2, offsetMax + 1);

  return (
    <nav>
      <ul className="pagination">
        {pagesCount > 5 && (
          <li className="page-item">
            <button
              className="btn btn-link rounded-0 rounded-start page-link"
              onClick={() => {
                if (currentPage > 1) onPageChange(currentPage - 1);
              }}
            >
              <i
                style={currentPage === 1 ? { color: "gray" } : {}}
                className="fas fa-backward"
              ></i>
            </button>
          </li>
        )}
        {pages.map((page, index) => (
          <li
            key={`pages.${index}`}
            className={page === currentPage ? "page-item active" : "page-item"}
          >
            <button
              className="btn btn-link rounded-0 page-link"
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
        {pagesCount > 5 && (
          <li className="page-item">
            <button
              className="btn btn-link rounded-0 rounded-end page-link"
              onClick={() => {
                if (currentPage !== pagesCount) onPageChange(currentPage + 1);
              }}
            >
              <i
                style={currentPage === pagesCount ? { color: "gray" } : {}}
                className="fas fa-forward"
              ></i>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
